import { Observable } from 'rxjs';

import { AnnouncementButtonModel } from './announcement-button.model';
import { AnnouncementType } from './announcement-type.enum';

export interface TitleRedirectionSuggestion {
    text: string;
    url?: string;
    shouldFocusOnInit: boolean;
}

export class AnnouncementModel {

    public primaryButton: AnnouncementButtonModel;
    public secondaryButton: AnnouncementButtonModel;
    public borderlessButton: AnnouncementButtonModel;
    public importance = 1;
    public index = 0;

    constructor(
        public announcementType: AnnouncementType,
        public title: string,
        public subTitle?: string,
        public iconClass?: string,
        public dismissCookieName?: string,
        public alignBottom: boolean = false,
        // cssClass used for setting the background color of the announcement.
        public cssClass?: string,
        // cssClass used for setting the font color of the announcement.
        public fontCssClass?: string,
        public dismissObservable?: Observable<boolean>,
        public dismissible?: boolean,
        public titleRedirectionSuggestion?: TitleRedirectionSuggestion,
        public dismissTimeoutInSecond?: number,
        public titleUseSubtitleStyle?: boolean
    ) {
    }

    public isValid(): boolean {
        return this.title && this.title.length > 0;
    }
}
